// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J-HU","questions":"styles_questions__3S0BD","footer":"styles_footer__YM1jT"};